(function () {'use strict';}());
angular.module("elidb").directive('wpHeader', function($document,$timeout,$window) {
    return {
      restrict: 'A',
      templateUrl: __DIR__+'/views/wp-header.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.$watch("state",function(value){
          if(!value) return;
          $scope.currentStateSelection = {value:"//"+$scope.state.toLowerCase()+".exceptionallives.org"};
        });

        

        $scope.onStateSelection = function() {
          if($scope.currentStateSelection.value === "") return;
          $window.location.href = $scope.currentStateSelection.value;
        };

        element.find("a").on("click",function(e){
        	e.preventDefault();
        	e.stopImmediatePropagation();
        	var url = $(this).attr("href");
        	$scope.$apply(function(){
        		$scope.externalLink(url).then(function(){
        			$window.location.href = url;
        		});
        	});
        });
      }  
    };
  });